<div class="flex flex-col place-content-center place-items-center main-container">
  <div id="on-top-container" class="flex flex-col">
    <div class="flex flex-col main-card" [ngStyle.gt-xs]="{'border': '1px solid #dadce0'}">
      <div class="flex flex-row place-content-center place-items-center logo-container">
        <img src="/assets/QUORUM-LOGO-2020.png">
      </div>
      <h3>Unauthorized</h3>
      <h4>No license found</h4>
      <p class="mat-body-1">
        Please contact Quorum's Customer Solutions Team for more information. CustomerSolutions@quorumdms.com or
        1-877-770-0036, Ext 520
      </p>
    </div>
    <div class="flex flex-row place-content-end place-content-start footer-container">
      <a href="http://quorumdms.com/privacy.htm">Privacy</a>
    </div>
  </div>

</div>